import React, { useState } from "react";

import "./NoteComment.css";
import NoteCommentForm from "./NoteCommentForm";
import { Edit } from "@mui/icons-material";

import { getFormattedDate } from "utils/date";
import { DATE_FORMAT } from "static/date";
import { useSelector } from "react-redux";

const NoteComments = ({
  comments,
  showCommentForm,
  reportId,
  contentId,
  setShowNoteCommentForm,
  isClinicActiveOrReviewTab,
}) => {
  const [selectedComment, setSelectedComment] = useState({});
  const { hasReportNoteEditAccess } = useSelector(
    (state) => state.transmission
  );

  return (
    <div className="d-flex g-1 flex-column">
      {showCommentForm && Object.keys(selectedComment).length === 0 && (
        <NoteCommentForm
          reportId={reportId}
          contentId={contentId}
          comment={selectedComment}
          handleCancel={() => {
            setShowNoteCommentForm(false);
            setSelectedComment({});
          }}
        />
      )}

      {comments?.map((comment, index) => {
        const commentedDate = comment?.updated_at || comment?.created_at;
        const commentedUser =
          comment?.updated_by?.name || comment?.created_by?.name;

        return selectedComment?._id === comment?._id ? (
          <NoteCommentForm
            reportId={reportId}
            contentId={contentId}
            comment={selectedComment}
            handleCancel={() => {
              setShowNoteCommentForm(false);
              setSelectedComment({});
            }}
          />
        ) : (
          <div key={index} className="comment-container d-flex g-1">
            <span className="separator" />
            <div className="comment-card">
              <p>{comment?.text}</p>
              <div className="comment-info">
                <span>{commentedUser}</span>
                <span>
                  {getFormattedDate(commentedDate, DATE_FORMAT.DEFAULT)}
                </span>
                <span>
                  {getFormattedDate(
                    commentedDate,
                    DATE_FORMAT.TIME_ONLY_WITHOUT_SECONDS
                  )}
                </span>
              </div>
            </div>

            {!hasReportNoteEditAccess && isClinicActiveOrReviewTab && (
              <Edit
                fontSize="small"
                className="edit-icon"
                onClick={() => {
                  setSelectedComment(comment);
                  setShowNoteCommentForm(true);
                }}
              />
            )}
          </div>
        );
      })}
    </div>
  );
};

export default NoteComments;
